export type Lang = "fr" | "en";

export interface Strings {
  brand_sub: string;
  runtime: string;
  max_depth: string;
  ndl: string;
  tts: string;
  profile: string;
  results: string;
  deco: string;
  tissues: string;
  waypoints: string;
  gases: string;
  gf: string;
  gf_low: string;
  gf_high: string;
  tank: string;
  settings: string;
  depth: string;
  duration: string;
  ascent: string;
  descent: string;
  sac: string;
  tank_vol: string;
  tank_p: string;
  last_stop: string;
  add: string;
  no_deco: string;
  cns: string;
  otu: string;
  gas_used: string;
  gas_end: string;
  preview: string;
  time: string;
  stop: string;
  stops: string;
  bottom: string;
  planned: string;
  depth_curve: string;
  ceiling: string;
  tank_pressure: string;
  light: string;
  dark: string;
  live: string;
  disclaimer: string;
}

export const STR: Record<Lang, Strings> = {
  fr: {
    brand_sub: "Planificateur Bühlmann",
    runtime: "Runtime",
    max_depth: "Profondeur max",
    ndl: "Sans palier",
    tts: "Remontée totale",
    profile: "Profil de plongée",
    results: "Résultats",
    deco: "Schedule de décompression",
    tissues: "Compartiments tissulaires",
    waypoints: "Points de plongée",
    gases: "Mélanges gazeux",
    gf: "Facteurs de gradient",
    gf_low: "GF Bas",
    gf_high: "GF Haut",
    tank: "Bouteille",
    settings: "Paramètres",
    depth: "Profondeur",
    duration: "Durée",
    ascent: "Vitesse remontée",
    descent: "Vitesse descente",
    sac: "Conso. surface",
    tank_vol: "Volume",
    tank_p: "Pression",
    last_stop: "Dernier palier",
    add: "Ajouter",
    no_deco: "Pas de décompression — remontée directe",
    cns: "CNS",
    otu: "OTU",
    gas_used: "Gaz consommé",
    gas_end: "P fin",
    preview: "Aperçu animé",
    time: "Temps",
    stop: "Palier",
    stops: "paliers",
    bottom: "Fond",
    planned: "planifié",
    depth_curve: "Profondeur",
    ceiling: "Plafond",
    tank_pressure: "Pression bouteille",
    light: "Clair",
    dark: "Sombre",
    live: "Live",
    disclaimer: "Outil de planification — ne remplace pas un ordinateur de plongée",
  },
  en: {
    brand_sub: "Bühlmann planner",
    runtime: "Runtime",
    max_depth: "Max depth",
    ndl: "No-deco",
    tts: "Time to surface",
    profile: "Dive profile",
    results: "Results",
    deco: "Decompression schedule",
    tissues: "Tissue compartments",
    waypoints: "Waypoints",
    gases: "Gas mixes",
    gf: "Gradient factors",
    gf_low: "GF Low",
    gf_high: "GF High",
    tank: "Tank",
    settings: "Settings",
    depth: "Depth",
    duration: "Duration",
    ascent: "Ascent rate",
    descent: "Descent rate",
    sac: "Surface SAC",
    tank_vol: "Volume",
    tank_p: "Pressure",
    last_stop: "Last stop",
    add: "Add",
    no_deco: "No decompression — direct ascent",
    cns: "CNS",
    otu: "OTU",
    gas_used: "Gas used",
    gas_end: "End P",
    preview: "Animated preview",
    time: "Time",
    stop: "Stop",
    stops: "stops",
    bottom: "Bottom",
    planned: "planned",
    depth_curve: "Depth",
    ceiling: "Ceiling",
    tank_pressure: "Tank pressure",
    light: "Light",
    dark: "Dark",
    live: "Live",
    disclaimer: "Planning tool — does not replace a dive computer",
  },
};

export interface GasName {
  tag: string;
  cls: "air" | "nitrox" | "deep" | "o2";
  name: string;
}

export function gasName(g: { fO2: number }): GasName {
  const o2 = Math.round(g.fO2 * 100);
  if (o2 === 21) return { tag: "AIR", cls: "air", name: "Air" };
  if (o2 === 100) return { tag: "O₂", cls: "o2", name: "Oxygen" };
  if (o2 < 21) return { tag: `TX${o2}`, cls: "deep", name: `Trimix ${o2}` };
  if (o2 < 50) return { tag: `EAN${o2}`, cls: "nitrox", name: `Nitrox ${o2}` };
  return { tag: `EAN${o2}`, cls: "o2", name: `Nitrox ${o2}` };
}

export function gasMOD(fO2: number, ppO2 = 1.4): number {
  return Math.max(0, (ppO2 / fO2 - 1) * 10);
}
